export default __webpack_public_path__ + "static/01Cantera-ed8183614719c1edd3430db1bbe9ccdf.png";